export default __webpack_public_path__ + "91bc26e5.svg";